import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-content">
          <h2>Get In Touch</h2>
          <p>Ready to experience the finest premium cashews? Contact us today.</p>

          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon">📧</div>
              <div className="contact-details">
                <h3>Email Us</h3>
                <a href="mailto:mail@cashu.co.in">mail@cashu.co.in</a>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-image">
          <img src="/logo.png" alt="CASHU Logo" />
        </div>
      </div>
    </section>
  );
}

export default Contact;